import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import { toggleOverlay } from "../../store/slices/headerSlice";
import promises1 from "../../assets/free.png";
import promises2 from "../../img/banners/promise-2.png";
import promises3 from "../../assets/service-desk.png";
import promises4 from "../../img/banners/promise-4.png";
import NearbyStore from "../ProductDescription/NearbyStore";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import toast from "react-hot-toast";
import { CircularProgress } from "@mui/material";
import { fetchUserAsync, setToken } from "../../features/auth/authSlice";
import { trackEvent } from "../../analytics/gtag";
import { EVENTS } from "../../analytics/events";

function LoginPage({ toggleOverlay }) {
  const dispatch = useDispatch();
  const [openStore, setOpenStore] = useState(null);
  const [otpSent, setOtpSent] = useState(false); // Track OTP sent status
  const [enteredOTP, setEnteredOTP] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [otpLoading, setOtpLoading] = useState(false); // Track loading state for OTP actions
  const [errors, setErrors] = useState({});

  const handlePhoneCheckAndSendOTP = async (event) => {
    event.preventDefault();
    setOtpLoading(true);
    setErrors({}); // Clear previous errors

    if (phoneNumber?.length !== 10) {
      setErrors({ phone: "Please enter a valid 10-digit phone number." });
      setOtpLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}login_number/${phoneNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        setOtpSent(true);
        toast.success("OTP sent successfully.");
      } else {
        setErrors({
          phone: "Mobile number is not registered with Cyclecircle.",
        });
      }
    } catch (error) {
      // console.error("API error:", error.message);
      toast.error("Please try again later.");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    setOtpLoading(true);
    setErrors({});
    if (enteredOTP.length === 6) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}login_number_otp/${phoneNumber}/${enteredOTP}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          toast.success("OTP verified successfully.");
          document.cookie = `UserID=${data.UserID}`;
          document.cookie = `token=${data.token}`;
          await dispatch(setToken(data.token));
          dispatch(fetchUserAsync(data.UserID));

          // Track login event here
          trackEvent({
            action: EVENTS.LOGIN,
            category: "Authentication",
            label: "User Logged In",
          });

          setPhoneNumber(null);
          toggleOverlay();
        } else {
          setErrors({ OTP: "Please enter a valid 6-digit OTP." });
          // console.error("API request failed:", response.statusText);
        }
      } catch (error) {
        // console.error(
        //   "An error occurred during the API request:",
        //   error.message
        // );
        toast.error("Please try again later");
      } finally {
        setOtpLoading(false);
      }
    } else {
      setErrors({ OTP: "Please enter a valid 6-digit OTP." });
      setOtpLoading(false);
    }
  };

  const handleSubmitPincode = (e) => {
    e.preventDefault();
    const pincode = e.target.elements.pincode.value;
    setOpenStore(pincode);
  };

  useEffect(() => {
    if (phoneNumber?.length < 10) {
      setErrors({});
    }
  }, [phoneNumber]);

  return (
    <div className="w-full h-full p-4 text-white-1 text-center relative">
      <div className="flex flex-col items-center justify-center w-full">
        <form
          onSubmit={handlePhoneCheckAndSendOTP}
          className="flex flex-col items-center w-full"
        >
          <label
            htmlFor="phoneNumber"
            className="w-full text-left text-sm mb-2"
          >
            Mobile Number
          </label>
          <input
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            value={phoneNumber}
            placeholder="Mobile number"
            maxLength={10}
            pattern="\d{10}"
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className={`w-full ${
              errors.phone ? "mb-2" : "mb-4"
            } p-3 rounded bg-white-1 text-black-4 placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-yellow-400`}
            required
          />
          {errors.phone && (
            <p className="text-red-500 text-xs w-full text-left mb-2">
              {errors.phone}
            </p>
          )}

          {otpSent && (
            <>
              <input
                type="text"
                placeholder="Enter OTP"
                value={enteredOTP}
                onChange={(e) => {
                  const numericOTP = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 6);
                  setEnteredOTP(numericOTP);
                }}
                onKeyDown={(e) => {
                  if (
                    e.key === " " ||
                    (isNaN(Number(e.key)) && e.key.length === 1)
                  ) {
                    e.preventDefault();
                  }
                }}
                maxLength={6}
                className={`w-full ${
                  errors.OTP ? "mb-2" : "mb-4"
                } p-3 rounded bg-white-1 text-black-4 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-yellow-400`}
              />
              {errors.OTP && (
                <p className="text-red-500 text-xs w-full text-left mb-2">
                  {errors.OTP}
                </p>
              )}
            </>
          )}

          <button
            type="submit"
            onClick={otpSent ? handleVerifyOTP : handlePhoneCheckAndSendOTP}
            className="w-full bg-yellow-400 hover:bg-yellow-500 font-semibold py-3 rounded mb-4 flex justify-center items-center"
            disabled={otpLoading}
          >
            {otpLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : otpSent ? (
              "Verify OTP"
            ) : (
              "Send OTP"
            )}
          </button>
        </form>
      </div>

      <div className="w-full flex flex-col items-center">
        <p className="text-sm font-semibold text-center">
          Find the nearest Cyclecircle.one dealership to make your purchase
          directly.
        </p>
        <form
          className="w-full flex justify-center mt-4 text-black-1"
          onSubmit={handleSubmitPincode}
        >
          <input
            type="text"
            name="pincode"
            inputMode="numeric"
            pattern="[0-9]*"
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            maxLength={6}
            placeholder="Enter Pincode"
            className="w-[65%] h-[35px] p-2 rounded-l bg-zinc-800 placeholder-gray-400 border-none focus:outline-none"
            required
          />
          <button
            type="submit"
            className="w-[30%] h-[35px] p-2 rounded-r bg-green text-white-1 text-sm tracking-wide font-medium border-none outline-none"
          >
            Check
          </button>
        </form>
      </div>

      <div className="text-xs text-gray-400 text-center mt-2 space-y-1">
        <p>Having trouble? Feel free to reach us</p>
        <div className="flex justify-center gap-3">
          <span className="flex items-center gap-1">
            <LocalPhoneIcon className="text-sm" /> +91-8839478882
          </span>
          <span className="flex items-center gap-1">
            <EmailIcon className="text-sm" /> support@cyclecircle.one
          </span>
        </div>
        <p>
          <Link
            to="/support"
            className="underline [text-underline-offset:3px]"
            onClick={toggleOverlay}
          >
            Privacy Policy
          </Link>{" "}
          &{" "}
          <Link
            to="/support"
            className="underline [text-underline-offset:3px]"
            onClick={toggleOverlay}
          >
            Terms of Service
          </Link>{" "}
          apply.
        </p>
      </div>

      <hr className="my-2" />

      <div className="w-full flex justify-between items-start py-2 overflow-x-auto gap-2 sm:gap-4">
        {[
          { img: promises1, label: "Free Delivery" },
          { img: promises4, label: "Quick Tracking Info" },
          { img: promises2, label: "Hassle Free Return" },
          { img: promises3, label: "24 Hours Issue Resolution" },
        ].map((item, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center w-[70px] sm:w-[80px] md:w-[90px] px-2"
          >
            <LazyLoadImage
              src={item.img}
              alt={item.label}
              className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 object-contain mb-2"
              effect="blur"
              wrapperProps={{ style: { transitionDelay: "1s" } }}
            />
            <span className="text-xs text-white-1 font-medium text-center">
              {item.label}
            </span>
          </div>
        ))}
      </div>

      {openStore && openStore?.length === 6 && (
        <>
          {/* Background Overlay */}
          <div className="fixed inset-0 bg-black-1 bg-opacity-60 z-[1000]" />

          {/* Modal Container */}
          <div
            className={`
        fixed bg-white-1 z-[1001] rounded-[10px]
        left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2
        w-[1000px] h-[600px]

        md:w-[1000px] md:h-[600px] md:top-[50%] md:-translate-y-[50%]

        sm:w-full sm:h-screen sm:top-0 sm:left-1/2 sm:-translate-x-1/2 sm:translate-y-0
      `}
          >
            <NearbyStore openStore={openStore} setOpenStore={setOpenStore} />
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {
  toggleOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
